// @core/api/endpoints/apikey/get_api_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  APIKeyResponse,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Get API key
 * Retrieves metadata for a specific API key including name, scopes, restrictions, and usage statistics. Does not return the actual key value for security reasons.
 */
export async function GetAPIKey(
  key_id: string,
  options?: RequestOptions
): Promise<APIKeyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/api-keys/:key_id`;
  requestPath = requestPath.replace(':key_id', encodeURIComponent(key_id));
  const requestOptions = options;
  return client.get<APIKeyResponse>(requestPath, { ...requestOptions });
}
